import React from 'react';
import classes from './TermsOfService.module.scss';
import { CenteredContentLayout } from '../../../components/containers/CenteredContentLayout';
import { TermsOfServiceContent } from './TermsOfServiceContent.view';
import topNavClasses from '../../TopNav/TopNav.module.scss';
import logo from 'assets/images/logo.svg';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

export const TermsOfServiceView = (): JSX.Element => {
  const { isLoggedIn } = useAuth();

  return (
    <div className={classes.TermsOfService}>
      {!isLoggedIn ? (
        <div className={classes.NotLoggedIn}>
          <div className={topNavClasses.TopNav}>
            <Link to={'/'} className={topNavClasses.Logo}>
              <img src={logo} alt={'logo'} />
            </Link>
          </div>
          <h3>Terms & Conditions</h3>
          <TermsOfServiceContent />
        </div>
      ) : (
        <CenteredContentLayout hasSidebar={false}>
          <TermsOfServiceContent />
        </CenteredContentLayout>
      )}
    </div>
  );
};
